import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BookUser, ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { Reveal } from "./Reveal";

export const NameOfDay = () => {
  const [name, setName] = React.useState(null);

  React.useEffect(() => {
    api.get("/names/name-of-the-day").then((r) => setName(r.data)).catch(() => {});
  }, []);

  if (!name) return null;

  return (
    <section className="bg-forest text-cream grain-overlay" data-testid="name-of-day-section">
      <div className="max-w-4xl mx-auto px-6 py-24">
        <Reveal>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="relative rounded-3xl border border-gold/30 bg-night/25 p-8 md:p-12 text-center overflow-hidden"
            data-testid="name-of-day-card"
          >
            <p className="uppercase tracking-[0.25em] text-xs text-gold-soft mb-6 flex items-center justify-center gap-2">
              <BookUser className="w-4 h-4" /> Name of the Day
            </p>
            <h3 className="font-serif text-5xl md:text-6xl text-gold leading-tight mb-4" data-testid="name-of-day-name">
              {name.name}
            </h3>
            {name.meaning ? (
              <p className="text-cream/80 text-lg leading-relaxed mb-8 max-w-xl mx-auto">{name.meaning}</p>
            ) : (
              <p className="text-cream/55 italic mb-8">A name from the Yorùbá naming tradition.</p>
            )}
            <Link
              to="/names"
              data-testid="name-of-day-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-gold hover:text-gold-light transition-colors"
            >
              Browse all Yorùbá names
              <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};

export default NameOfDay;
